import { InstantSchema, type Instant } from "@/Temporal"
import { objectSchema } from "vue-utils"
import type { IncidentEntity } from "./IncidentEntity"
import { LatLng } from "./LatLng"

export interface IncidentLocation extends IncidentEntity {
	receivedAt: Instant
	position: LatLng
}

export const IncidentLocation = objectSchema<IncidentLocation>({
	id: Number,
	receivedAt: InstantSchema,
	position: LatLng,
})
